"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicReimbursementHeader = void 0;
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const claim_1 = require("shared/claim");
const util_1 = require("shared/util");
require("./clinic-reimbursement-header.less");
const ramda_1 = require("ramda");
const store_4 = require("client/modules/app-settings/store");
const app_settings_1 = require("shared/app-settings");
let ClinicReimbursementHeader = class ClinicReimbursementHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.filterDate = "";
        this.siteId = -1;
        this.startDate = "";
        this.endDate = "";
        this.claimStatus = claim_1.ClaimStatus.Dispensed;
        this.dateOptions = [
            {
                id: 0,
                label: "January 1 - January 15",
                value: ["", "01", "15"].join("-")
            },
            {
                id: 1,
                label: "January 16 - January 31",
                value: ["", "01", "31"].join("-")
            },
            {
                id: 2,
                label: "February 1 - February 15",
                value: ["", "02", "15"].join("-")
            },
            {
                id: 3,
                label: "February 16 - February 28",
                value: ["", "02", "28"].join("-")
            },
            {
                id: 4,
                label: "February 16 - February 29",
                value: ["", "02", "29"].join("-")
            },
            {
                id: 5,
                label: "March 1 - March 15",
                value: ["", "03", "15"].join("-")
            },
            {
                id: 6,
                label: "March 16 - March 31",
                value: ["", "03", "31"].join("-")
            },
            {
                id: 7,
                label: "April 1 - April 15",
                value: ["", "04", "15"].join("-")
            },
            {
                id: 8,
                label: "April 16 - April 30",
                value: ["", "04", "30"].join("-")
            },
            {
                id: 9,
                label: "May 1 - May 15",
                value: ["", "05", "15"].join("-")
            },
            {
                id: 10,
                label: "May 16 - May 31",
                value: ["", "05", "31"].join("-")
            },
            {
                id: 11,
                label: "June 1 - June 15",
                value: ["", "06", "15"].join("-")
            },
            {
                id: 12,
                label: "June 16 - June 30",
                value: ["", "06", "30"].join("-")
            },
            {
                id: 13,
                label: "July 1 - July 15",
                value: ["", "07", "15"].join("-")
            },
            {
                id: 14,
                label: "July 16 - July 31",
                value: ["", "07", "31"].join("-")
            },
            {
                id: 15,
                label: "August 1 - August 15",
                value: ["", "08", "15"].join("-")
            },
            {
                id: 16,
                label: "August 16 - August 31",
                value: ["", "08", "31"].join("-")
            },
            {
                id: 17,
                label: "September 1 - September 15",
                value: ["", "09", "15"].join("-")
            },
            {
                id: 18,
                label: "September 16 - September 30",
                value: ["", "09", "30"].join("-")
            },
            {
                id: 19,
                label: "October 1 - October 15",
                value: ["", "10", "15"].join("-")
            },
            {
                id: 20,
                label: "October 16 - October 31",
                value: ["", "10", "31"].join("-")
            },
            {
                id: 21,
                label: "November 1 - November 15",
                value: ["", "11", "15"].join("-")
            },
            {
                id: 22,
                label: "November 16 - November 30",
                value: ["", "11", "30"].join("-")
            },
            {
                id: 23,
                label: "December 1 - December 15",
                value: ["", "12", "15"].join("-")
            },
            {
                id: 24,
                label: "December 16 - December 31",
                value: ["", "12", "31"].join("-")
            }
        ];
        this.headerToggle = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_1.reportsStore.loadClinicReimbursement(this.siteId, this.claimStatus, this.startDate, this.endDate, true);
        };
        this.handleChangeDate = (value) => {
            if (value === "all") {
                this.selectedEndDate = "all";
                this.startDate = "all";
                this.endDate = "all";
            }
            else {
                this.selectedEndDate = value;
                // create start date
                const enddateArray = this.selectedEndDate.split("-");
                const arraytouse = enddateArray.slice(0, -1);
                if (enddateArray[2] <= "15") {
                    arraytouse.push("01");
                }
                else {
                    arraytouse.push("16");
                }
                this.selectedStartDate = arraytouse.join("-");
                this.startDate = this.selectedStartDate;
                this.endDate = this.selectedEndDate;
            }
        };
        // Too lazy to figure out how to determine  which is which based on e.target.
        // So just rewrote pretty much the same functions for the date picker buttons
        // but for the individual start and end dates.
        // private readonly handleClickTodayStart = () => {
        //   const date = new Date().toDateString();
        //   this.startDate = moment(date).format("YYYY-MM-DD");
        // };
        // private readonly handleClickTodayEnd = () => {
        //   const date = new Date().toDateString();
        //   this.endDate = moment(date).format("YYYY-MM-DD");
        // };
        // private readonly handleClickClearStart = () => {
        //   this.startDate = "";
        // };
        // private readonly handleClickClearEnd = () => {
        //   this.endDate = "";
        // };
        // private readonly handleDatePickerChangeStart = (value: Date) => {
        //   this.startDate = moment(value).format("YYYY-MM-DD");
        // };
        // private readonly handleDatePickerChangeEnd = (value: Date) => {
        //   this.endDate = moment(value).format("YYYY-MM-DD");
        // };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
    }
    async componentDidMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            await store_2.sitesListStore.loadSitesNoRelation();
        }
        // relate to date period options
        const payPeriods = await store_4.appSettingsStore.readSettings(app_settings_1.AppOption.EobPayPeriods, true);
        this.payPeriods = Number(payPeriods.value);
        // console.log("this.payperiods", this.payPeriods);
        // max pay Periods to load: 48 (2 years)
        if (this.payPeriods > 48) {
            this.payPeriods = 48;
        }
        this.selectedStartDate = moment()
            .startOf("month")
            .format("YYYY-MM-DD");
    }
    get availableOptions() {
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: site.displayName || site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    get availableDateOptions() {
        const options = [];
        // const payPeriods = this.payPeriods;
        const currentDate = new Date();
        // const month = currentDate.getMonth();
        const year = currentDate.getFullYear();
        const prevyear = String(year - 1);
        const twoYearsAgo = String(year - 2);
        // const nextyear = year + 1; // just for testing if isLeap year test works
        const isLeap = (year) => new Date(year, 1, 29).getDate() === 29;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let removed;
        // create 3 separate dateOptions arrays that will be spliced individually based on leap year
        const dateOptionsCurrent = this.dateOptions.map(e => e);
        const dateOptionsPrevyear = this.dateOptions.map(e => e);
        const dateOptionsTwoYearsAgo = this.dateOptions.map(e => e);
        if (isLeap(year)) {
            removed = dateOptionsCurrent.splice(3, 1);
        }
        else {
            removed = dateOptionsCurrent.splice(4, 1);
        }
        if (isLeap(Number(prevyear))) {
            removed = dateOptionsPrevyear.splice(3, 1);
        }
        else {
            removed = dateOptionsPrevyear.splice(4, 1);
        }
        if (isLeap(Number(twoYearsAgo))) {
            removed = dateOptionsTwoYearsAgo.splice(3, 1);
        }
        else {
            removed = dateOptionsTwoYearsAgo.splice(4, 1);
        }
        // filter through dateOptions to get specified periods (from dev settings) in available options
        const startRanges = dateOptionsCurrent.map(e => e.label.split(" - ")[0]);
        const curDate = moment().date();
        const lastRange = curDate <= 15 ? 16 : 1;
        // to start with current range
        const currentRange = curDate <= 15 ? 1 : 16;
        // const subMonth = curDate <= 15 ? 2 : 1; // to always get period one month ago
        const subMonth = curDate <= 15 ? 1 : 0; // to always get the previous period
        const endMonth = moment()
            .subtract(subMonth, "month")
            .format("MMMM");
        const endMonthCurrent = moment().format("MMMM");
        const lastRangeSearch = `${endMonth} ${lastRange}`;
        const currentRangeSearch = `${endMonthCurrent} ${currentRange}`;
        const currentRangeToUse = currentRangeSearch.concat(" - ", `${endMonthCurrent} ${curDate} (${year})`);
        const currentValueToUse = moment().format("YYYY-MM-DD");
        // console.log("lastRangeSearch", lastRangeSearch);
        // console.log("currentRangeSearch", currentRangeSearch);
        const lastRangeIndex = startRanges
            .map((d, i) => {
            if (d.includes(lastRangeSearch)) {
                return i;
            }
            return null;
        })
            .filter(e => {
            if (e === null) {
                return false;
            }
            return true;
        })[0];
        // console.log("lastRangeIndex", lastRangeIndex);
        // console.log("currentRangeIndex", currentRangeIndex);
        let index = lastRangeIndex;
        let indexYear = String(year);
        for (let realX = 1; realX <= this.payPeriods; realX++) {
            const x = realX - 1;
            const currentOptionIndexToAdd = lastRangeIndex - x;
            if (currentOptionIndexToAdd < 0) {
                if (24 + currentOptionIndexToAdd < 0) {
                    if (index === 0) {
                        options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                        indexYear = prevyear;
                    }
                    else {
                        options.push(ramda_1.clone(dateOptionsTwoYearsAgo[index]));
                        indexYear = twoYearsAgo;
                    }
                    index = 48 + currentOptionIndexToAdd;
                    options[x].id = realX;
                    options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                    options[x].label = options[x].label.concat(" ", `(${indexYear})`);
                }
                else {
                    if (index === 0) {
                        options.push(ramda_1.clone(dateOptionsCurrent[index]));
                        indexYear = String(year);
                    }
                    else {
                        options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                        indexYear = prevyear;
                    }
                    index = 24 + currentOptionIndexToAdd;
                    options[x].id = realX;
                    options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                    options[x].label = options[x].label.concat(" ", `(${indexYear})`);
                }
            }
            else {
                options.push(ramda_1.clone(dateOptionsCurrent[index]));
                index = currentOptionIndexToAdd;
                indexYear = String(year);
                options[x].id = realX;
                options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                options[x].label = options[x].label.concat(" ", `(${indexYear})`);
            }
        }
        // remove the first element of the array - duplicate of previous period
        options.shift();
        // add current period at beginning of array
        options.unshift({
            id: 1,
            label: currentRangeToUse,
            value: currentValueToUse
        });
        // add all periods option at beginning of array
        options.unshift({
            id: 0,
            label: "All Periods",
            value: "all"
        });
        // console.log("date options", this.dateOptions);
        // console.log("options", options);
        return options;
        // do not return full options array with two year range - just the last two periods
        // return options.slice(0, 2);
    }
    render() {
        const { title } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "40%", top: "25%", width: "25%", overflowY: true, buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { className: "" },
                        React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, onInputChange: e => {
                                util_1.pharmacyDropDownHandler({
                                    id: Number(this.siteId),
                                    search: e
                                });
                            }, value: String(this.siteId) || "", width: "100%" }),
                        React.createElement("br", null),
                        React.createElement(select_1.MaterialSelect, { options: this.availableDateOptions, required: true, searchable: true, label: "Pay Period", onSelect: this.handleChangeDate, value: String(this.selectedEndDate) || "", width: "100%" }))))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "claimStatus", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "payPeriods", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "selectedEndDate", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "selectedStartDate", void 0);
__decorate([
    mobx_1.observable
], ClinicReimbursementHeader.prototype, "dateOptions", void 0);
__decorate([
    mobx_1.computed
], ClinicReimbursementHeader.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], ClinicReimbursementHeader.prototype, "availableDateOptions", null);
__decorate([
    mobx_1.action
], ClinicReimbursementHeader.prototype, "handleChangeDate", void 0);
ClinicReimbursementHeader = __decorate([
    mobx_react_1.observer
], ClinicReimbursementHeader);
exports.ClinicReimbursementHeader = ClinicReimbursementHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/clinic-reimbursement/components/clinic-reimbursement-header/clinic-reimbursement-header.tsx
// module id = 3889
// module chunks = 0